import * as React from "react";
import Helmet from "react-helmet";
import { Header } from "./Header";
import { withRouter, RouteComponentProps } from "react-router";
import { useQueryParams } from "../helpers";
import { FocusableHeader } from ".";

export interface AppPageProps extends RouteComponentProps {
  headerExtension?: React.ReactNode;
  heading?: string;
  headingClass?: string;
  hideLogin?: boolean;
  subHeading?: { id: string } | React.ReactNode;
  outerClassName?: string;
  innerClassName?: string;
  bannerClassName?: string;
  title?: string;
  children: React.ReactNode;
}

const AppPage: React.FunctionComponent<AppPageProps> = props => {
  const {
    headerExtension,
    heading,
    headingClass,
    hideLogin,
    subHeading,
    outerClassName,
    innerClassName,
    title,
    children,
    bannerClassName,
  } = props;
  useQueryParams(props);

  return (
    <>
      <Helmet>
        <title>{title || heading}</title>
      </Helmet>
      <Header hideLogin={hideLogin} />
      <div className={`appPage ${outerClassName ? outerClassName : ""}`}>
        {headerExtension}
        {(heading || subHeading) && (
          <div
            className={`appPage__banner ${
              bannerClassName ? bannerClassName : ""
            }`}
          >
            {heading && (
              <FocusableHeader className={headingClass || ""} text={heading} />
            )}
            {subHeading && (
              <div className="ds-text ds-u-margin-top--1">{subHeading}</div>
            )}
          </div>
        )}
        <div
          className={`appPage__content ${innerClassName ? innerClassName : ""}`}
        >
          {children}
        </div>
      </div>
    </>
  );
};

export default withRouter(AppPage);
